// extracted by mini-css-extract-plugin
module.exports = {"container":"Feature_container__UEPUK","text":"Feature_text__8E4c_"};